/**
 *
 * @param  {Array} userRouter 后台返回的用户权限json
 * @param  {Array} allRouter  前端配置好的所有动态路由的集合
 * @return {Array} realRoutes 过滤后的路由
 */

export function recursionRouter (userRouter = [], allRouter = []) {
    var realRoutes = [];
    allRouter.forEach((v, i) => {
        userRouter.forEach((item, index) => {
            if (item.name === v.meta.name) {
                if (item.children && item.children.length > 0) {
                    v.children = recursionRouter(item.children, v.children);
                } else {
                    v.children = [];
                }
                // else {
                //     if (v.children == undefined) {
                //         v.children = [];
                //     } else {
                //         v.children.map(item => {
                //             item.meta.isShow = false;
                //         })
                //     }
                // }
                realRoutes.push(v);
            }
        });
    });
    return realRoutes;
}

/**
 *
 * @param {Array} routes 用户过滤后的路由
 *
 * 递归为所有有子路由的路由设置第一个children.path为默认路由
 */
export function setDefaultRoute (routes) {
    routes.forEach((v, i) => {
        if (v.children && v.children.length > 0) {
            if (document.documentElement.clientWidth <= 768 && v.path == '/') {
                v.redirect = { name: "mobileHome" };
            } else {
                v.redirect = { name: v.children[0].name };
                setDefaultRoute(v.children);
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/utils/recursion-router.js